import { render, staticRenderFns } from "./VehiclesForm.vue?vue&type=template&id=70ea6b3f&scoped=true&"
import script from "./VehiclesForm.vue?vue&type=script&lang=js&"
export * from "./VehiclesForm.vue?vue&type=script&lang=js&"
import style0 from "./VehiclesForm.vue?vue&type=style&index=0&id=70ea6b3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea6b3f",
  null
  
)

export default component.exports